import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalcloseService {

  prefferedAgentCloseModal$ = new BehaviorSubject(false);

  closePrefferedAgentModal(): void {
    this.prefferedAgentCloseModal$.next(true);
  }
}
